// src/app/admin/functions/getCampaignType.ts
import {httpsCallable} from "firebase/functions";
import {useEffect, useMemo, useState} from "react";
import {Functions} from "../../../firebase/firebase";
import {usePersistedState} from "../../../global/hooks/usePersisted";

export type CampaignTypeData = {
  id: string;
  title?: string;
  info?: {
    header_image: string;
    infopage_imagetype: "Single" | "Multi";
    infopage_info: string;
    infopage_title: string;
    items: any[];
  };
  item_tags?: string[];
  type: number;
};

export function useCampaignTypes(tags: string[] | undefined) {
  const [data, setData] = usePersistedState<
    CampaignTypeData[] | null | undefined
  >("campaignTypes", undefined);
  const [loading, setLoading] = useState<boolean>(!!tags);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!tags) return;
    setLoading(true);
    setError(null);
    const fn = httpsCallable(Functions, "call-admin-campaign-getCampaignType");
    fn({tags})
      .then((res) => {
        const types = (res.data as any)?.response;
        setData(types.flat());
      })
      .catch((e: any) => setError(e?.message ?? "Ukjent feil"))
      .finally(() => setLoading(false));
  }, [tags]);

  return {data, loading, error};
}
